import { render } from "./StandardLiveCulturePrintPage.vue?vue&type=template&id=07970654&scoped=true"
import script from "./StandardLiveCulturePrintPage.vue?vue&type=script&lang=js"
export * from "./StandardLiveCulturePrintPage.vue?vue&type=script&lang=js"

import "./StandardLiveCulturePrintPage.vue?vue&type=style&index=0&id=07970654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07970654"]])

export default __exports__